import {RestResource} from '../rest'
import {athubAxios} from '../../util'
import {COMPANY_SERVER} from '../server'

const company = new RestResource({server: COMPANY_SERVER, resource: 'company'});

company.page = (params) => {
    return new Promise((resolve, reject) => {
        let url = `${COMPANY_SERVER}/companies/selectPageList`;
        athubAxios.post(url, params).then(responseBody => {
            resolve(responseBody.data);
        }).catch(error => {
            reject(error);
        });
    });
}

company.get = (params) => {
    return new Promise((resolve, reject) => {
        let url = `${COMPANY_SERVER}/companies/selectOne`;
        athubAxios.post(url, params).then(responseBody => {
            resolve(responseBody.data);
        }).catch(error => {
            reject(error);
        });
    });
}

company.getById = (id) => {
    return new Promise((resolve, reject) => {
        let url = `${COMPANY_SERVER}/companies/selectById`;
        athubAxios.post(url, {companiesid: id}).then(responseBody => {
            resolve(responseBody.data);
        }).catch(error => {
            reject(error);
        });
    });
};

company.vendorlist = () => {
    return new Promise((resolve, reject) => {
        let url = `${COMPANY_SERVER}/companies/findByType`;
        athubAxios.post(url, {
            token: localStorage.getItem("token"),
            appId: "WEB",
            type: 'VENDOR',
        }).then(responseBody => {
            resolve(responseBody.data.list);
        }).catch(error => {
            reject(error);
        });
    });
}

company.getAllValidList = () => {
    return new Promise((resolve, reject) => {
        let url = `${COMPANY_SERVER}/companies/selectAllValid`;
        athubAxios.post(url, {
            token: localStorage.getItem("token"),
            appId: "WEB",
        }).then(responseBody => {
            resolve(responseBody.data.list);
        }).catch(error => {
            reject(error);
        });
    });
}

company.getAllByIds = (param) => {
    return new Promise((resolve, reject) => {
            let url = `${COMPANY_SERVER}/companies/selectByIdsOrNames`;
    athubAxios.post(url, {
        token: localStorage.getItem("token"),
        appId: "WEB",
        ids:param
    }).then(responseBody => {
        resolve(responseBody.data.list);
}).catch(error => {
        reject(error);
});
});
}


export default company;
